module.exports = __webpack_public_path__ + "static/top180-be721cff520b79aa8c290185e3b8d47d.png";